import styled, { css } from "styled-components";
import { FC } from "react";
import { components } from "react-select";

import { styleWrappedComponent } from "./styleWrappedComponent";
import { SelectComponentProps } from "./types";

const StyledValueContainer = styled(components.ValueContainer)`
  gap: 2px;
  ${styleWrappedComponent(css``)};
`;

type ValueContainerProps = SelectComponentProps["ValueContainer"];

export const ValueContainer: FC<ValueContainerProps> = ({
  children,
  ...props
}) => <StyledValueContainer {...props}>{children}</StyledValueContainer>;
